import { createPinia, defineStore } from 'pinia';
import { ref, computed } from 'vue';
import type { BreakpointState } from '@global-types/breakpoint.ts';

export const useScreensizeStore = defineStore('screensize', () => {
  const isMobile = ref<boolean>(window.BREAKPOINTS.isMobile);
  const isTablet = ref<boolean>(window.BREAKPOINTS.isTablet);
  const isTabletLarge = ref<boolean>(window.BREAKPOINTS.isTabletLarge);
  const isDesktop = ref<boolean>(window.BREAKPOINTS.isDesktop);

  const isMobileOrTablet = computed<boolean>(() => isMobile.value || isTablet.value);

  const setBreakpoints = (breakpoints: BreakpointState): void => {
    isMobile.value = breakpoints.isMobile;
    isTablet.value = breakpoints.isTablet;
    isTabletLarge.value = breakpoints.isTabletLarge;
    isDesktop.value = breakpoints.isDesktop;
  };

  return {
    isMobile,
    isTablet,
    isTabletLarge,
    isDesktop,
    isMobileOrTablet,
    setBreakpoints,
  };
});

export const piniaScreensize = createPinia();
